import { render, staticRenderFns } from "./statictics-item.vue?vue&type=template&id=972bb524&scoped=true"
import script from "./statictics-item.vue?vue&type=script&lang=ts"
export * from "./statictics-item.vue?vue&type=script&lang=ts"
import style0 from "./statictics-item.vue?vue&type=style&index=0&id=972bb524&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972bb524",
  null
  
)

export default component.exports